import Chelia5Attic1 from './Chelia 5 3 Lantai (1).webp'
import Chelia5Attic2 from './Chelia 5 3 Lantai (2).webp'



const Chelia5Atticimages =[
Chelia5Attic1,Chelia5Attic2
]

export default Chelia5Atticimages;